import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface BulkEditFilterBannerProps {
  totalFilteredCount: number;
  selectedCount: number;
  applyToAllFiltered: boolean;
  onToggle: () => void;
}

export function BulkEditFilterBanner({
  totalFilteredCount,
  selectedCount,
  applyToAllFiltered,
  onToggle,
}: BulkEditFilterBannerProps) {
  return (
    <div className="p-4 border border-orange-200 dark:border-orange-800 rounded-lg bg-orange-50 dark:bg-orange-950/40">
      <div className="flex items-center gap-3">
        <AlertTriangle className="h-5 w-5 text-orange-600" />
        <div className="flex-1">
          <p className="text-sm font-medium text-orange-900">
            {totalFilteredCount} total items match your current filters
          </p>
          <p className="text-xs text-orange-700">
            You can apply this change to all {totalFilteredCount} items, not just the{" "}
            {selectedCount} currently selected
          </p>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={onToggle}
          className={applyToAllFiltered ? "bg-orange-100 border-orange-300 dark:bg-orange-900/40 dark:border-orange-800" : ""}
        >
          {applyToAllFiltered ? "Apply to All" : "Apply to Selected Only"}
        </Button>
      </div>
    </div>
  );
}
